<template>
  <CustomCreateDialog
    dialogTitle="فعال کردن پلن VIP برای کاربر"
    dialogId="add-vip-to-user"
    okTitle="ثبت"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendAddVipToUserRequest"
  >
    <BCol cols="12">
      <VipPlanPicker @getPlanId="setPlanId"></VipPlanPicker>
      <UserPicker isInDialog @getUser="setUserId"></UserPicker>
    </BCol>
  </CustomCreateDialog>
</template>

<script>
export default {
  emits: ["updateVipUsersList"],
  data() {
    return {
      isOkButtonDisabled: false,
      activateVipPlanPayload: {
        id: null, // Vip Plan ID
        userId: null,
      },
    };
  },
  methods: {
    async sendAddVipToUserRequest() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let addVipPlanToUser = new AddVipPlanToUser(_this);
        addVipPlanToUser.setRequestParam(_this.activateVipPlanPayload);
        await addVipPlanToUser.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "افزوده شد",
                icon: "CheckIcon",
                variant: "success",
                text: "پلن با موفقیت به کاربر افزوده شد",
              },
            });
            _this.activateVipPlanPayload = {
              id: null,
              userId: null,
            };
            _this.$emit("updateVipUsersList");
            _this.$bvModal.hide("add-vip-to-user");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره امتحان کنید!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
    setPlanId(planId) {
      this.activateVipPlanPayload.id = planId;
    },
    setUserId(userId) {
      this.activateVipPlanPayload.userId = userId;
    },
  },
  components: {
    CustomCreateDialog,
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
    VipPlanPicker,
    UserPicker,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VipPlanPicker from "@/views/components/VipUser/VipPlanPicker.vue";
import UserPicker from "@/views/components/Users/UserPicker.vue";
import { AddVipPlanToUser } from "@/libs/Api/VipUser";
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
</script>
